<template>
  <div class="ip-project-detail-wrap">
    <TitleCard :title="`专利信息分析`"
               :showMore="false"
               :loading="loading"
               :isEmpty="isEmpty">
    </TitleCard>
    <div v-if="!isEmpty">
      <a-list item-layout="horizontal"
              :data-source="resultList">
        <a-list-item size="small"
                     slot="renderItem"
                     key="item.id"
                     slot-scope="item">
          <a-list-item-meta :description="item.dateRange">
            <a slot="title"
               @click="toDetails(item.id)">{{ item.name }}</a>
            <a-avatar slot="avatar"
                      src="/static/icon-shezhi.svg" />
          </a-list-item-meta>
          <div>{{ item.publishDate }}</div>
        </a-list-item>
      </a-list>
      <Pagination ref="pagination"
                  :total="total"
                  @change="handlerPaginationChange"></Pagination>
    </div>
  </div>
</template>

<script>
import { getIndustryList } from '@/api/IpProject.js'
import Pagination from './components/pagination'
export default {
  data() {
    return {
      isEmpty: false,
      resultList: [],
      list: [],
      title: '', //标题名
      total: 20,
      id: 0,
      // 最初的请求数据的分页参数
      paginationOpt: {
        currentPage: 1,
        pageNumber: 1,
        pageSize: 10,
      },
      loading: false,
      defaultParams: {},
    }
  },
  mounted() {
    this.getSearchParams()
    this.loadData(this.defaultParams)
  },
  components: {
    Pagination,
  },
  methods: {
    // 渲染列表数据
    async loadData(params) {
      try {
        this.loading = true
        const { data, total } = await getIndustryList(params)
        this.isEmpty = data.length === 0
        this.resultList = data
        this.total = total
      } catch (error) {
        this.$apiStatusHandler(99, error.message)
      } finally {
        this.loading = false
      }
    },
    // 获取默认参数
    getSearchParams() {
      const { id, name } = this.$route.query
      this.id = id
      this.title = name.slice(3, -6)
      this.defaultParams = {
        ...this.paginationOpt,
        monitor_id: id,
        push_state: 2,
      }
    },
    // 跳转详情页面
    toDetails(id) {
      this.$router.push({ name: 'IndustryInformationDetail', query: { id } })
    },
    // 分页器参数变化，带动列表的数据变化
    handlerPaginationChange() {
      const paginationRef = this.$refs.pagination
      const params = {
        pageNumber: paginationRef.currentPage || 1,
        pageSize: paginationRef.pageSize || 10,
        push_state: 2,
        monitor_id: this.id,
      }
      console.log(params)
      this.loadData(params)
    },
  },
}
</script>

<style scoped lang="scss">
/deep/.detail-box {
  min-height: 400px;
  .ant-list-item-meta-avatar {
    width: 48px;
    height: 48px;
    margin-right: 10px;
    .ant-avatar-image {
      display: inline-block;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
